/**
 * Layout of the embedded-emissions fields on a UK importer's emission factor form.
 *
 * Backend docs/features/uk-cbam-emission-factors, S7 (D12, D13): a UK importer types in two
 * figures, direct (required) and indirect (optional). For now they sit side by side in one
 * section. The arrangement lives here, not in EmissionsDataTab's JSX, so that rearranging the
 * UK form is an edit to this list. Field names are the form's own (`buildUkFactorPayload`
 * reads them), so only the grouping, order, widths and labels are free to change.
 *
 * The EU form is not described here: its indirect figure is calculated from an electricity
 * breakdown, which is behaviour rather than layout.
 *
 * Keys carry the namespace, as `buildElectricitySourceOptions` does, so the key extractor files
 * them under `installations`.
 *
 * @param {import('i18next').TFunction} t
 * @returns {Array<{ key: string, title: string, fields: Array<{ name: string, label: string,
 *   required?: boolean, numeric?: boolean, colSpan: number }> }>}
 */
export const buildUkEmissionsLayout = (t) => [
  {
    key: 'embedded',
    title: t('installations:emissions.embedded', 'Embedded Emissions'),
    fields: [
      {
        name: 'specificDirectEmission',
        label: t(
          'installations:emissions.specificDirect',
          'Specific (direct) embedded emissions (tCO2/tonne of product)',
        ),
        required: true,
        numeric: true,
        colSpan: 6,
      },
      {
        name: 'specificIndirectEmission',
        label: t(
          'installations:emissions.specificIndirect',
          'Specific (indirect) embedded emissions (tCO2/tonne of product)',
        ),
        numeric: true,
        colSpan: 6,
      },
    ],
  },
];
